$(document).ready(function(){
    $('.product__image-slider-arrows .arrow-right').click(function(){
        $('.product__image-slider').slick('slickNext');
    });

    $('.product__image-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    // if (window.innerWidth > 767) {
    //     const section = document.querySelector('.product-information__grid');
    //     const content = section.querySelector('.product-details .group-block');

    //     function updateHeight() {
    //     section.style.height =
    //         content.offsetHeight + window.innerHeight + 'px';
    //     }

    //     updateHeight();
    //     window.addEventListener('resize', updateHeight);

    //     const observer = new IntersectionObserver(
    //     ([entry]) => {
    //         section.classList.toggle('is-active', entry.isIntersecting);
    //     },
    //     {
    //         threshold: 0,
    //     }
    //     );

    //     observer.observe(section);
    // }
});

(function () {
        const section = document.querySelector('.product-information__media-desktop');
        const image = document.querySelector('.product__image-slider');

        function handleScroll() {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const scrollY = window.scrollY;

            const scrollInSection = scrollY - sectionTop;
            const maxScroll = sectionHeight * 0.5;

            let progress = scrollInSection / maxScroll;
            progress = Math.min(Math.max(progress, 0), 1);

            // scale: 0.9 → 1
            const scale = 0.9 + progress * 0.1;

            // translateX: -20% → 0
            const translateX = -20 + progress * 20;

            image.style.transform = `scale(${scale}) translateX(${translateX}%)`;
        }

        window.addEventListener('scroll', handleScroll);
        handleScroll();
})();
